import React from 'react';
import PortfolioSections from '../components/PortfolioSections';

export default function Portfolio() {
  return (
    <div className="App">
      <PortfolioSections />
    </div>
  );
}
